// import 'babel-polyfill';
import './bugsnag';

// General import
import Lodash from 'lodash';
import Vue from 'vue';
import LineClamp from 'vue-line-clamp';
import Vuelidate from 'vuelidate';
import VueSessionStorage from 'vue-sessionstorage'

import Axios from 'axios';
import VueAxios from 'vue-axios';
import VueCookie from 'vue-cookie';
import VueCarousel from 'vue-carousel';

Vue.use(Lodash);
Vue.use(LineClamp);
Vue.use(VueAxios, Axios);
Vue.use(VueCookie);
Vue.use(Vuelidate);
Vue.use(VueSessionStorage);
Vue.use(VueCarousel);

// Directives
import dataHref from './directives/dataHref';

Vue.directive('data-href', dataHref);

// Import components
import Bericht from '../components/Bericht';
import Berichten from '../components/Berichten';
import Contactformulier from '../components/Contactformulier';
import CookieBar from '../components/CookieBar';
import Dienstenformulier from '../components/Dienstenformulier';
import Kernwaarden from '../components/Kernwaarden';
import Personeel from '../components/Personeel';
import Klanten from '../components/Klanten';
import Spinner from 'vue-spinner-component/src/Spinner';


new Vue({
    el: '#vue-container',
    components: {
        Bericht,
        Berichten,
        Contactformulier,
        CookieBar,
        Dienstenformulier,
        Kernwaarden,
        Klanten,
        Personeel,
        Spinner,
    },
    data() {
        return {
            menuActive: false,
        };
    },
    methods: {
        menu() {
            this.menuActive = !this.menuActive;

            let body = document.querySelector('body');

            if (this.menuActive) {
                body.classList.add('menu-opened');
            } else {
                body.classList.remove('menu-opened');
            }
        },
    },
    created() {
        this.axios.defaults.headers.common = {
            'X-Requested-With': 'XMLHttpRequest',
            'X-CSRF-TOKEN': document.querySelector('meta[name="_token"]').getAttribute('content'),
        };
    },
});

Vue.config.productionTip = false;

console.log(' ');
console.log('%cSpreek jij onze taal?', 'font-weight: bold; color: black;');
console.log('%cGa naar https://bttr.nl/vacatures', 'font-weight: bold; color: black;');
console.log(' ');



// WEBPACK FOOTER //
// ./resources/assets/js/app.js